module.exports = __webpack_public_path__ + "img/sold-out-GT.00f4b56.png";